export const LISTE_PRODUITS_UNITAIRES = {
  title: 'Ajouter une face unitaire',
  repertoire: 'Devis',
  racine: 'Accueil',
  location: 'Location : {location}',
  periode: 'du {dateDebut} au {dateFin}',
  brief: 'Mon brief',
  panier: 'Panier',
  actions: {
    back: 'Retour',
    search: 'Rechercher',
  },
  query: {
    from: 'Du',
    for: 'Pour',
    to: 'Au',
    location: 'Location',
  },
  table: {
    reference: 'Référence',
    format: 'Format',
    materiel: 'Matériel',
    address: 'Adresse',
    zipCode: 'CP',
    city: 'Ville',
    affectation: 'Affectations',
    societe: 'Societé',
    disposition: 'Disposition',
  },
  errors: {
    datesRequired: 'La date de début et la date de fin sont obligatoires',
    produitLoc: 'Le produit de location est obligatoire',
    produitDefaultLoc: 'Aucun produit de location par défaut n\'est lié a la face',
    errorProduitLocationNotFound: 'Impossible de trouver le produit de location dans la société',
    dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin',
    problemOccurred: 'Un problème est survenu',
  },
  briefContent: {
    au: 'au',
    brief: 'Mon brief',
    appliquerBrief: 'Appliquer les paramètres de votre brief',
    location: 'Location',
    periode: 'Période',
    references: 'Référence(s)',
    villes: 'Ville',
    departements: 'Département',
    materiels: 'Matériel',
    formats: 'Format',
    appliquer: 'Appliquer',
    reinitialiser: 'Réinitialiser',
    budgetMax: 'Budget max',
    societe: 'Société',
    locationDefault: 'Produit location par défaut',
    adresse: 'Adresse',
    eclaire: 'Eclairé',
  },
  panierContent: {
    panier: 'Panier',
    sousTitle: '{numberProduit} produits dans votre panier',
    panierVide: 'Votre panier est vide',
    total: 'Total',
    reseauPerso: 'Créer un réseau personnalisé',
    noProduct: 'Sélectionnez des produits',
    add: 'Ajouter',
    datePeriode: 'Du {dateDebut} au {dateFin}',
    noNewProduct: 'Aucun produit ajouté via l\'écran de sélection',
    produitFromDCF: 'Produit(s) présent(s) dans {typeDCF}',
    newSelection: 'Nouvelle sélection',
    clearSelection: 'Vider ma sélection',
    type: {
      devis: 'le devis',
      commande: 'la commande',
      facture: 'la facture',
    },
  },
};

export const AJOUT_PRODUIT_UNITAIRE = {
  title: 'Ajouter une face unitaire',
  success: 'Face ajoutée',
  duplicate: 'Face déjà ajoutée a cette date',
  error: 'Cette face ne peut être ajoutée',
};

export const POPUP_AFFECTATION = {
  actions: {
    close: 'Fermer',
  },
  title: 'Affectation(s) de la face {code}',
  datePeriode: 'Du {dateDebut} au {dateFin}',
  periodeInfini: 'A partir du {dateDebut}',
  table: {
    type: 'Type',
    libelle: 'Affectation',
    dates: 'Dates',
  },
  type: {
    reseau: 'Affectation TEMPO',
    commande: 'Affectation LC',
  },
};
